module.exports = __webpack_public_path__ + "media/application/images/research-analyst-bg-67b35864bdb2d41190b35abd57cbde85.png";